"use strict";

var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.NewVisitor = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../../kameleoonData"),
  _kameleoonError = require("../../kameleoonError"),
  _types = require("../types"),
  _logging = require("../../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var NewVisitor = /*#__PURE__*/function () {
  function NewVisitor(a) {
    _classCallCheck(this, NewVisitor);
    var b = a.visitorType;
    _defineProperty(this, "visitorType", void 0), this.visitorType = b;
  }
  return _createClass(NewVisitor, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.targetingData;
      var c = null === b || void 0 === b ? void 0 : b[_kameleoonData.KameleoonData.VisitsData];
      if (!c || !this.visitorType) return (0, _tsRes.Ok)(!1);
      var d = c.visits,
        e = !d.length;
      switch (this.visitorType) {
        case _types.VisitorType.NEW:
          return (0, _tsRes.Ok)(e);
        case _types.VisitorType.RETURNING:
          return (0, _tsRes.Ok)(!e);
        default:
          _logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Unexpected visitor type for NewVisitor condition: ", ""])), this.visitorType), (0, _kameleoonError.exhaustCheck)(this.visitorType);
      }
    }
  }]);
}();
exports.NewVisitor = NewVisitor;